customElements.component = "product-recommendations";

if (!customElements.get(customElements.component)) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      this.initVariables();
    }

    initVariables() {
      this.disableRecommendationsLogic = this.dataset.disableRecommendationsLogic == 'true';
      this.productRecommendationsSlider = this.querySelector('.js-product-recommendations-slider');
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
    }

    connectedCallback() {
      if (this.disableRecommendationsLogic){
        this.initSlider();
      } else {
        this.fetchRecommendations();
      }
    }

    disconnectedCallback() {
      this.slider?.destroy();
    }

    initSlider() {
      if (!this.productRecommendationsSlider) return;
      const params = {
        slidesPerView: 1.5,
        spaceBetween: 16,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 26,
          }
        }
      }

      this.slider = new Swiper(this.productRecommendationsSlider, params);
    }

    fetchRecommendations() {
      fetch(window.Shopify.routes.root + `recommendations/products?product_id=${this.productId}&section_id=${this.sectionId}&intent=related`)
      .then(response => response.text())
      .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.js-product-recommendations-slider');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.productRecommendationsSlider.innerHTML = recommendations.innerHTML;
          }
      })
      .finally(() => {
        this.initVariables();
        this.initSlider();
      });
    }
  }

  customElements.define(customElements.component, ProductRecommendations);
}